import styled from 'styled-components';
import { defaultColors, defaultTheme } from '@components/themes';
import { Flex } from '@components/Flex';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { TextPairing } from '@components/TextPairing';
import { Box } from '@components/Box';
import { PlaceholderCloudImage } from '@components/CloudImage';

export const PlanTogetherWrapper = styled(Box)`
  ${themeMediaQuery('below_sm')} {
    padding-left: ${themeSpace(5)};
    padding-right: ${themeSpace(5)};
  }
`;

export const PlanTogetherText = styled(TextPairing)`
  padding-left: ${themeSpace(10)};
  .text-pairing-title {
    max-width: 450px;
  }
  ${themeMediaQuery('below_sm')} {
    padding-left: ${themeSpace(8)};
    padding-right: ${themeSpace(8)};
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-body {
      padding-right: ${themeSpace(0)} !important;
    }
  }
  ${themeMediaQuery('sm')} {
    .text-pairing-title {
      max-width: 212px;
    }
    .text-pairing-body {
      padding-right: 234px !important;
    }
  }
  ${themeMediaQuery('md')} {
    .text-pairing-title {
      max-width: 450px;
    }
    .text-pairing-body {
      padding-right: 180px !important;
    }
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 470px;
    }
  }
`;

export const StyledFlexContainer = styled(Flex)`
  margin-top: -65px;
  z-index: 1;
  ${defaultTheme.mediaQueries.below_sm} {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  ${defaultTheme.mediaQueries.sm} {
    width: 1000px;
    margin-left: auto;
    margin-right: auto;
  }

  ${defaultTheme.mediaQueries.md} {
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }

  ${defaultTheme.mediaQueries.lg} {
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const StyledTextContainer = styled(Flex)`
  background-color: ${defaultColors.blue6};
  border-bottom-right-radius: 64px;
  border-top-right-radius: 4px;
  height: 500px;
  max-width: 600px;
  margin-left: -50px;
  align-self: center;

  ${defaultTheme.mediaQueries.below_sm} {
    margin: 0 auto;
    height: 410px;
    width: 100% !important;
    z-index: 9;
    max-width: unset;
  }

  ${defaultTheme.mediaQueries.sm} {
    min-width: 500px;
    margin-left: -50px;
    height: 540px;
  }

  ${defaultTheme.mediaQueries.md} {
    min-width: 600px;
    margin-left: -50px;
    height: 500px;
  }

  ${defaultTheme.mediaQueries.lg} {
    min-width: 600px;
    margin-left: 0px;
    margin-left: -50px;
  }
`;

export const StyledImage = styled.div`
  width: 100%;

  ${defaultTheme.mediaQueries.sm} {
    position: relative;
  }

  ${defaultTheme.mediaQueries.below_sm} {
    position: relative;
    bottom: -7px;
  }
`;

export const DesktopLazyLoadWrapper = styled.div`
  display: block;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const MobileLazyLoadWrapper = styled.div`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
  }
`;

export const StyledPlaceholderCloudImage = styled(PlaceholderCloudImage)`
  display: block;
  ${themeMediaQuery('below_sm')} {
    display: none;
    width: 96.7vw;
    margin-left: -20px;
  }
`;

export const StyledPlaceholderCloudImageMobile = styled(PlaceholderCloudImage)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
    width: 106%;
    margin-left: -6%;
  }
`;
